export default __webpack_public_path__ + "static/media/logoo2.ee9b16e8.png";